import { createToaster } from "@meforma/vue-toaster";

        const downloadCsvWithDates = async function(dates, getRecordsFunction, clientCode, title) {
            var data = await getRecordsFunction(clientCode, dates.startDate, dates.endDate);    
            this.downloadCsvFile(data, this.createFileName(dates.startDate, dates.endDate, clientCode, title));
        }

        const downloadCsvFile = async function(records, filename) {
            if(records == null || records.length === 0) {
                const toaster = createToaster({
                    position: 'top-right',
                    duration: 1000
                });

                toaster.success('No Data To Export');
            } 
            else {
                const csv = this.arrayToCsv(records);
                this.downloadBlob(csv, filename, 'text/csv;charset=utf-8;');    
            }

            return {success: true};
        }

        const arrayToCsv = function(data){
            let csv = '';
            let header = Object.keys(data[0]).join(',');

            // encode JSON so it retains structure
            data.forEach(row => {
                for(const prop in row) {
                    if((typeof row[prop] === 'string' || row[prop] instanceof String) ) {
                        row[prop] = row[prop].replaceAll(/"/g, '""');
                    }
                }
            })
            
            let values = data.map(o => Object.values(o).map(value => `"${value}"`).join(',')).join('\n');

            csv += header + '\n' + values;
            return csv;
        }

        const createFileName = function(startDate, endDate, clientCode, name) {
            let fileName = name + (clientCode != '' ? '_' + clientCode : '');

            if(startDate) {
                let local_startDate = new Date(startDate);
                local_startDate.setMinutes(local_startDate.getMinutes() + local_startDate.getTimezoneOffset());
                fileName += '_' +  local_startDate.getFullYear() + '_' + (local_startDate.getMonth() + 1) + '_' + local_startDate.getDate() + '-';
            } else {
                fileName += '_Up_To_'
            }

            let local_endDate = endDate ? new Date(endDate) : new Date();
            local_endDate.setMinutes(local_endDate.getMinutes() + local_endDate.getTimezoneOffset());
            fileName += local_endDate.getFullYear() + '_' + (local_endDate.getMonth() + 1) + '_' + local_endDate.getDate();

            return fileName + '.csv';
        }

        const downloadBlob = function(content, filename, contentType) {
            // Create a blob
            let blob = new Blob([content], { type: contentType });
            let url = URL.createObjectURL(blob);

            // Create a link to download it
            let pom = document.createElement('a');
            pom.href = url;
            pom.setAttribute('download', filename);
            pom.click();
        }

export const downloadCsv = {
    downloadCsvWithDates,
    downloadCsvFile,
    createFileName,
    downloadBlob,
    arrayToCsv   
}